module.exports = __webpack_public_path__ + "static/media/close-modal.f6c9c284.svg";